import { checkValueEmpty } from './checkValueEmpty';
export const getKeysPath = (obj, restrict = () => false, prefix = '') => {
    const keys = [];
    for (const key in obj) {
        if (restrict(key)) {
            keys.push(prefix + key);
            continue;
        }
        const value = obj[key];
        if (typeof value === 'object' && value !== null && !Array.isArray(value)) {
            keys.push(...getKeysPath(value, restrict, prefix + key + '/'));
            continue;
        }
        keys.push(prefix + key);
    }
    return keys;
};
export const getValueByPath = (obj, path) => {
    return path.split('/').reduce((acc, cur) => {
        if (typeof acc === 'object' && acc !== null && Object.prototype.hasOwnProperty.call(acc, cur)) {
            return acc[cur];
        }
        return undefined;
    }, obj);
};
export const getOperationType = (oldValue, newValue) => {
    const isNewEmpty = checkValueEmpty(newValue);
    const isOldEmpty = checkValueEmpty(oldValue);
    if (isNewEmpty && isOldEmpty) {
        return null;
    }
    if (isNewEmpty && !isOldEmpty) {
        return 'remove';
    }
    if (!isNewEmpty && isOldEmpty) {
        return 'add';
    }
    if (newValue !== oldValue) {
        return 'replace';
    }
    return null;
};
export const getPatchOperations = (oldOne, newOne, restrict = () => false) => {
    const paths = [...new Set([...getKeysPath(oldOne, restrict), ...getKeysPath(newOne, restrict)])];
    return paths.reduce((acc, cur) => {
        const oldValue = getValueByPath(oldOne, cur);
        const newValue = getValueByPath(newOne, cur);
        const operationType = getOperationType(oldValue, newValue);
        if (operationType !== null) {
            acc.push({
                op: operationType,
                path: '/' + cur,
                // каст типов пока оставил для совместимости со старым методом
                value: newValue,
            });
        }
        return acc;
    }, []);
};
